import getReferentialVersion from "./referentialVersion";
import {
  REFERENCIAL_APPLICATION_NAME,
  REFERENCIAL_VERSION,
} from "@/utils/sections";

// when changing IT SHOULD BE MODIFIED IN service-worker.js TOO
export const MANUAL_CACHE_VERSION = 4;

// REFERENCIAL_CACHE_NAME_WITHOUT_VERSION if a cache name. Inside it the is one key per project depending of the querystring
export const REFERENCIAL_CACHE_NAME_WITHOUT_VERSION = "ReferencialNodes";
// TECHNICAL_DOCUMENTS_CACHES_NAMES_WITHOUT_VERSION is all the keys for the technical support data
export const TECHNICAL_DOCUMENTS_CACHES_NAMES_WITHOUT_VERSION = {
  technicalSupportsDatas: "technicalSupportsDatas",
  templateSentencesDatas: "templateSentencesDatas",
  sectionPamphletsDatas: "sectionPamphletsDatas",
  qualityIndexesDatas: "qualityIndexesDatas",
  regulationDocumentsDatas: "regulationDocumentsDatas",
};
const cachesNamesWithoutVersion = [
  ...Object.values(TECHNICAL_DOCUMENTS_CACHES_NAMES_WITHOUT_VERSION),
  REFERENCIAL_CACHE_NAME_WITHOUT_VERSION,
];

/**
 * Get the correct url depending of the self.location.host to match cache key
 * @returns fake url for cache
 */
const getUrlCachePrefix = () => {
  let VITE_APP_RAPSOTEC_BACK_URL =
    "http://localhost:8085/referencial.referencial_services.";
  if (
    self.location.host === "front.development.infra-rapsotec.com"
    // ||
    // self.location.host === "www.rct.rapsotec.com"
  ) {
    VITE_APP_RAPSOTEC_BACK_URL =
      "https://front.development.infra-rapsotec.com/referencial.referencial_services.";
  } else if (self.location.host === "front.staging.infra-rapsotec.com") {
    VITE_APP_RAPSOTEC_BACK_URL =
      "https://front.staging.infra-rapsotec.com/referencial.referencial_services.";
  } else if (
    self.location.host === "rapsotec.com" ||
    self.location.host === "www.rapsotec.com"
  ) {
    VITE_APP_RAPSOTEC_BACK_URL =
      "https://back.rapsotec.com/referencial.referencial_services.";
  }

  return VITE_APP_RAPSOTEC_BACK_URL;
};

const removeOldCache = () => {
  if (window.caches) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        try {
          // name look like: sectionPamphletsDatas.DRAFT.CT_RAPSOTEC_MAROC.2
          const nameSplitted = name.split(".");

          // We alway check on the last key to be able to improve code and add subkey without breaking code and clean cache
          const lengthNameSplitted = nameSplitted.length;
          // We check that the cache key is one of cachesNamesWithoutVersion with a version < at the one define manually
          if (
            nameSplitted.length > 1 &&
            cachesNamesWithoutVersion.includes(nameSplitted[0]) &&
            parseInt(nameSplitted[lengthNameSplitted - 1]) <
              MANUAL_CACHE_VERSION
          ) {
            caches.delete(name);
          }
        } catch (err) {
          // This should not happen
          console.error(err);
        }
      });
    });
  }
};

/*
Remove cache remove the current cache version
MANUAL_CACHE_VERSION != referentialVersion.
Changing MANUAL_CACHE_VERSION is only needed if data format change in front and we have to invalidate the cache even if referentialVersion doesn't change
This will delete the cache key that will delete all the cache entry for all the canvas referencial.
when referentialVersion change it remove the current cache of MANUAL_CACHE_VERSION
when MANUAL_CACHE_VERSION change it remove the cache stored before it. IT SHOULD BE MODIFIED IN service-worker.js TOO
*/
const removeCacheForReferencialNode = () => {
  if (window.caches) {
    //Remove actual cache
    caches.delete(
      `${REFERENCIAL_CACHE_NAME_WITHOUT_VERSION}.${MANUAL_CACHE_VERSION}`,
    );
  }
};

export const removeTechnicalDocumentCaches = () => {
  if (window.caches) {
    //Remove actual cache
    Object.values(TECHNICAL_DOCUMENTS_CACHES_NAMES_WITHOUT_VERSION).forEach(
      (cacheNameWithoutVersion) => {
        // Related objects are cached in theirs two version 'Current' and 'DRAFT' by application_name. (e.g => technicalSupportsDatas.DRAFT.CT_RAPSOTEC_FRANCE.${MANUAL_CACHE_VERSION})
        for (const [key] of Object.entries(REFERENCIAL_APPLICATION_NAME)) {
          caches.delete(
            `${cacheNameWithoutVersion}.${REFERENCIAL_VERSION.current}.${REFERENCIAL_APPLICATION_NAME[key]}.${MANUAL_CACHE_VERSION}`,
          );
          caches.delete(
            `${cacheNameWithoutVersion}.${REFERENCIAL_VERSION.draft}.${REFERENCIAL_APPLICATION_NAME[key]}.${MANUAL_CACHE_VERSION}`,
          );
        }
      },
    );
  }
};

export const retrieveCacheKeyForProjectId = async (projectId) => {
  if (!projectId) return undefined;

  const cache = await caches.open(`ReferencialNodes.${MANUAL_CACHE_VERSION}`);
  const keys = await cache.keys();
  const specificProjectKey = keys.find((key) => {
    // key is a request object with a url key like: "https://back-grpc-web.referencial.development.k8s.infra-socotec.netreferencial.referencial_services.ReferencialNodes"
    // This is automatically done by service worker
    const keyUrl = new URL(key.url);
    // We only want to delete cache for the concerned project
    return (
      keyUrl.pathname ===
        "/referencial.referencial_services.ReferencialNodes" &&
      keyUrl.searchParams.get("versionName") === REFERENCIAL_VERSION.current &&
      keyUrl.searchParams.get("project") === projectId.toString()
    );
  });

  return specificProjectKey;
};

export const getAllProjectsCacheKeys = async () => {
  const referencialCaches = await caches.open(
    `ReferencialNodes.${MANUAL_CACHE_VERSION}`,
  );
  const keys = await referencialCaches.keys();
  const allProjectsKeys = keys.filter((key) => {
    // key is a request object with a url key like: "https://back-grpc-web.referencial.development.k8s.infra-socotec.netreferencial.referencial_services.ReferencialNodes"
    // This is automatically done by service worker
    const keyUrl = new URL(key.url);
    // We want to delete cache for all projects
    return (
      keyUrl.pathname ===
        "/referencial.referencial_services.ReferencialNodes" &&
      keyUrl.searchParams.get("versionName") === REFERENCIAL_VERSION.current
    );
  });
  return { caches: referencialCaches, allProjectsKeys };
};

export const removeCacheForAllprojects = async () => {
  if (window.caches) {
    const { caches, allProjectsKeys } = await getAllProjectsCacheKeys();
    for (const key of allProjectsKeys) {
      await caches.delete(key);
    }
  }
};

/*
Remove only cache for one project.
Used when canvas configuration change
*/
export const removeCacheForProjectId = async (projectId) => {
  if (window.caches) {
    const cache = await caches.open(`ReferencialNodes.${MANUAL_CACHE_VERSION}`);
    const specificProjectKey = await retrieveCacheKeyForProjectId(projectId);
    await cache.delete(specificProjectKey);
  }
};

export const removeCacheIfReferentialVersionChange = async () => {
  // We always try to remove old. If it is already deleted it will do nothing
  // Impact the current cache ONLY when MANUAL_CACHE_VERSION increment.
  removeOldCache();
  const referentialVersion = await getReferentialVersion();
  if (localStorage) {
    if (referentialVersion.toString() !== localStorage.referentialVersion) {
      removeCacheForReferencialNode();
      removeTechnicalDocumentCaches();
      localStorage.setItem("referentialVersion", referentialVersion);
    }
  } else {
    console.warn(
      "Can't configure localstorage for service worker, localstorage is disabled",
    );
    removeTechnicalDocumentCaches();
    removeCacheForReferencialNode();
  }
};

export const retrieveCache = async (url, params = "") => {
  const cache = await caches.match(`${getUrlCachePrefix()}${url}?${params}`);

  if (cache) {
    return cache.json();
  }
  return null;
};

export const deleteCache = async (cacheName) => {
  const cache = await caches.open(`${cacheName}.${MANUAL_CACHE_VERSION}`);
  const cacheDeleted = await cache.delete(`${getUrlCachePrefix()}${cacheName}`);

  return cacheDeleted;
};

export const putCache = async ({ data, cacheName, params = "" } = {}) => {
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: "application/json",
  });
  const newCache = await caches.open(`${cacheName}.${MANUAL_CACHE_VERSION}`);
  const reponse = new Response(blob);
  const request = new Request(`${getUrlCachePrefix()}${cacheName}?${params}`);

  await newCache.put(request, reponse);

  return true;
};
